module.exports = __webpack_public_path__ + "media/src/images/icon__magazinQuestion-a48673b45961b530c4dc7d17ef4809e6.svg";